/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/helper/formHelper.js":
/*!*************************************!*\
  !*** ./src/js/helper/formHelper.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"fetchConfig\": () => (/* binding */ fetchConfig),\n/* harmony export */   \"serializeForm\": () => (/* binding */ serializeForm)\n/* harmony export */ });\nconst fetchConfig = (type = 'json') => {\n  return {\n    method: 'POST',\n    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },\n  };\n};\n\nconst serializeForm = (form) => {\n  const obj = {};\n  const formData = new FormData(form);\n\n  for (const key of formData.keys()) {\n    const regex = /(?:^(properties\\[))(.*?)(?:\\]$)/;\n\n    if (regex.test(key)) {\n      obj.properties = obj.properties || {};\n      obj.properties[regex.exec(key)[2]] = formData.get(key);\n    } else {\n      obj[key] = formData.get(key);\n    }\n  }\n\n  return JSON.stringify(obj);\n};\n\n\n//# sourceURL=webpack://ergoobject-shopify/./src/js/helper/formHelper.js?");

/***/ }),

/***/ "./src/js/productForm.js":
/*!*******************************!*\
  !*** ./src/js/productForm.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _web_components_ProductForm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./web-components/ProductForm */ \"./src/js/web-components/ProductForm.js\");\n\n\ncustomElements.define('product-form', _web_components_ProductForm__WEBPACK_IMPORTED_MODULE_0__[\"default\"]);\n\n\n//# sourceURL=webpack://ergoobject-shopify/./src/js/productForm.js?");

/***/ }),

/***/ "./src/js/web-components/ProductForm.js":
/*!**********************************************!*\
  !*** ./src/js/web-components/ProductForm.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n/* harmony export */ });\n/* harmony import */ var _helper_formHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/formHelper */ \"./src/js/helper/formHelper.js\");\n\n\nclass ProductForm extends HTMLElement {\n  constructor() {\n    super();\n\n    this.form = this.querySelector('form');\n\n    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));\n  }\n\n  onSubmitHandler(evt) {\n    evt.preventDefault();\n    const submitButton = this.querySelector('[type=\"submit\"]');\n    if (submitButton.classList.contains('button--loading')) return;\n\n    this.handleErrorMessage();\n\n    submitButton.setAttribute('aria-disabled', true);\n    submitButton.classList.add('button--loading');\n\n    const config = (0,_helper_formHelper__WEBPACK_IMPORTED_MODULE_0__.fetchConfig)('javascript');\n    config.headers['X-Requested-With'] = 'XMLHttpRequest';\n    config.body = JSON.stringify({\n      ...JSON.parse((0,_helper_formHelper__WEBPACK_IMPORTED_MODULE_0__.serializeForm)(this.form)),\n    });\n\n    fetch(`${routes.cart_add_url}`, config)\n      .then((response) => response.json())\n      .then((response) => {\n        if (response.status) {\n          this.handleErrorMessage(response.description);\n          return;\n        }\n\n        console.log('added', response);\n\n        document.dispatchEvent(new CustomEvent('cart:update', { detail: { openMiniCart: true } }));\n\n        submitButton.classList.add('button--success');\n\n        setTimeout(() => {\n          submitButton.classList.remove('button--success');\n        }, 2000);\n\n        //this.cartNotification.renderContents(response);\n      })\n      .catch((e) => {\n        console.error(e);\n      })\n      .finally(() => {\n        submitButton.classList.remove('button--loading');\n        submitButton.removeAttribute('aria-disabled');\n      });\n  }\n\n  handleErrorMessage(errorMessage = false) {\n    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');\n    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');\n\n    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);\n\n    if (errorMessage) {\n      this.errorMessage.textContent = errorMessage;\n    }\n  }\n}\n\n/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductForm);\n\n\n//# sourceURL=webpack://ergoobject-shopify/./src/js/web-components/ProductForm.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/js/productForm.js");
/******/ 	
/******/ })()
;